import React from 'react';
import {
  Container,
  Input,
  InputContainer,
  Label,
} from './styles';

export function DateInput({
  label = 'Label',
  date = '',
  onChangeDate = () => {},
}) {

  return (
    <Container>
      <Label>{label}</Label>
      <InputContainer>
        <Input
          onChange={(e) => onChangeDate(e.target.value)}
          value={date}
          type="date"
        />
      </InputContainer>
    </Container>
  );
}